.cs{outline:none;}